<template>
  <div id="modal-online-certificate" class="mbsc-cloak">
    <img src="https://www.724.co.th/uploads/oic-online-certificate.jpg" alt="ใบอนุญาตเป็นนายหน้าประกันวินาศภัย" />
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>